import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InputGroup, FormControl, Button } from 'react-bootstrap';
import _ from 'underscore';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Tab, Tabs } from 'react-bootstrap';

import { Job } from 'services/action';

import { Select, Form } from 'ui/components';

import JobPickup from './job.pickup';
import JobLastMile from './job.last_mile';
import JobConsole from './job.console';

const initialState = {
  job: [],
  filter: null,
  search: '',
  notFounds: null,
  codes: '',
  currentSelected: [],
  checkedAll: false,
};

export const FormJob = ({
  manifest,
  type,
  onSelected,
  destination,
  origin,
  selected,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [key, setKey] = React.useState('pick');
  const [loading, setLoading] = React.useState(false);

  const [{ job, filter, search, codes, notFounds, currentSelected, checkedAll }, setState] =
    React.useState(initialState);

  const $handleSelected = async (e, i) => {
    let newJobs = [...job];
    let jo = { ...newJobs[i], is_checked: e };
    newJobs[i] = jo;

    setState((prevState) => ({ ...prevState, job: newJobs }));

    let nd = currentSelected ? currentSelected : [];

    if (e) {
      nd.push(newJobs[i]);
    } else {
      nd.forEach((d, ix) => {
        if (d.id === newJobs[i].id) {
          nd.splice(ix, 1);
        }
      });
    }

    setState((prevState) => ({ ...prevState, currentSelected: nd }));
    onSelected(nd);
  };

  const $handleSelectAll = async (e, i) => {
    setLoading(true);

    let nd = [];

    _.each(job, function(jo) {
      let x = {...jo, is_checked: e}

      if (e) {
        nd.push(x)
      }
    })

    setState((prevState) => ({ ...prevState, currentSelected: nd }));
    onSelected(nd);
  };

  const $handleFilterService = async (e) => {
    setState((prevState) => ({
      ...prevState,
      filter: { ...prevState?.filter, service: e },
    }));
  };

  const queryJob = (status, manifest_id) => {
    let query = {
      type: type === 'return' ? 'last_mile' : type,
      exclude: 'ftl',
      status,
      limit: 1000,
    };

    if (filter?.service) {
      query.service_type_id = filter?.service?.id;
    }

    if (type !== 'pickup') {
      if (origin) {
        query.hub_id = origin?.id;
      }
    }

    if (search) {
      query.search = search;
    }

    return query;
  };

  const manifestJobs = async () => {
    if (!manifest) return [];

    let jobs = [];
    if (manifest?.jobs) {
      const job_selecteds = await manifest?.jobs.map((g) => ({
        ...g,
        is_checked: true,
      }));

      jobs.push(...job_selecteds);
    }

    if (jobs.length > 0) {
      let temp = [];
      jobs.forEach((e) => {
        if (e?.is_checked === true) {
          temp?.push(e);
        }
      });
      // setState((prevState) => ({ ...prevState, selected: temp }));
      onSelected(temp);
    }

    return jobs;
  };

  const coverageJob = async (e) => {
    let jobs = [];
    const res = await Dispatch(Job.$get(queryJob('unmanifested', '')));

    if (res && res?.message === 'success' && res?.data) {
      let cover = await e?.coverages?.map((h) => h?.village_id);

      const job_selecteds = await res?.data?.map((g) => ({
        ...g,
        is_checked: cover?.includes(g?.destination?.region?.village_id),
      }));

      jobs.push(...job_selecteds);
    }

    if (jobs.length > 0) {
      let temp = [];
      jobs.forEach((e) => {
        if (e?.is_checked === true) {
          temp?.push(e);
        }
      });
      onSelected(temp);
    }
  };

  const pendingJobs = async () => {
    const res = await Dispatch(Job.$get(queryJob('unmanifested', '')));

    if (res && res?.message === 'success' && res?.data) {
      let pjs = res?.data;
      if (selected?.length > 0) {
        let shipment_ids = await selected?.map((d) => d?.id);

        const job_selecteds = await res?.data.map((g) => ({
          ...g,
          is_checked: shipment_ids?.includes(g?.id),
        }));

        pjs = job_selecteds;
      }
      return pjs;
    }

    return [];
  };

  const $setupJobs = async () => {
    const mj = await manifestJobs();
    const pj = await pendingJobs();

    setState((prevState) => ({ ...prevState, job: [...mj, ...pj] }));
  };

  const $handleSubmit = async () => {
    setLoading(true);
    let codeLists = codes?.split(',');
    codeLists = codes?.split('\n');

    let nd = [];
    let nf = [];
    codeLists?.forEach((c, i) => {
      let j = _.filter(job, function (jo) {
        return jo?.delivery_order?.shipment?.code === c?.replace(/ /g, '');
      });

      if (j?.length > 0) {
        nd = [...nd, ...j];
      } else {
        nf.push(c);
      }
    });

    setState((prevState) => ({ ...prevState, currentSelected: nd, notFounds: nf }));
    onSelected(nd);
    setLoading(false);
  };

  const $handleReset = () => {
    setState((prevState) => ({
      ...prevState,
      currentSelected: [],
      notFounds: null,
      codes: '',
    }));

    onSelected([]);
  };

  React.useEffect(() => {
    if (!type) return;
    $handleReset();
    $setupJobs();
  }, [type, origin, destination]);

  React.useEffect(() => {
    setState((prevState) => ({ ...prevState, currentSelected: selected }));
    onSelected(selected);
  }, [selected]);

  React.useEffect(() => {
    const handleSelect = async () => {
      let select = await currentSelected?.map((d) => d?.id);
      let newJobs = [...job];
      let jo = {};

      _.find(newJobs, function (item, i) {
        if (select?.includes(item?.id)) {
          jo = { ...item, is_checked: true };
          newJobs[i] = jo;
        } else {
          jo = { ...item, is_checked: false };
          newJobs[i] = jo;
        }
      });

      setState((prevState) => ({ ...prevState, job: newJobs }));
    };

    handleSelect();
  }, [JSON.stringify(currentSelected)]);

  React.useEffect(() => {
    if (!manifest) return;
    if (manifest) {
      if (type && origin) {
        $setupJobs();
      }
    }
  }, [manifest, type, origin]);

  React.useEffect(() => {
    if (manifest && !origin) return;
    $setupJobs();
  }, [filter, search, origin, manifest]);

  React.useEffect(() => {
    if (manifest) return;
    if (destination) {
      coverageJob(destination);
    }
  }, [destination]);

  React.useEffect(() => {
    let ca = false
    if (job?.length === currentSelected?.length) {
      ca = true
    }

    setState((prevState) => ({ ...prevState, checkedAll: ca }));
  }, [job, currentSelected])


  if (!job || !type) return null;

  return (
    <div className="">
      <Tabs
        className="bg-white tabs"
        justify
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab
          eventKey="pick"
          title="Pilih Shipment"
          tabClassName="section-title bg-white align-items-center justify-content-center"
        >
          <div className="bg-white border rounded">
            <div className="row p-3 ">
              {type !== 'pickup' && (
                <div className="col-md-4 col-12 mb-3 mb-md-0">
                  <Select.Remote
                    placeholder="Filter Layanan"
                    url="/tms/service/type"
                    row={(d) => {
                      return {
                        value: d?.id,
                        label: d?.name,
                      };
                    }}
                    onSelected={$handleFilterService}
                  />
                </div>
              )}

              <div className="col-md-4 col-12 mb-3 mb-md-0">
                <InputGroup className="search flex-nowrap input-group-flat bg-light">
                  <FormControl
                    placeholder="Cari ..."
                    value={search}
                    onChange={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        search: e.target.value,
                      }))
                    }
                    className="bg-light"
                  />
                  <div className="input-group-text">
                    {search ? (
                      <Fi.FiX
                        onClick={() =>
                          setState((prevState) => ({
                            ...prevState,
                            search: '',
                          }))
                        }
                      />
                    ) : (
                      <Fi.FiSearch />
                    )}
                  </div>
                </InputGroup>
              </div>
            </div>
            <div className="col-md-12 col-12 border-top">
              {type === 'pickup' ? (
                <JobPickup data={job} checkedAll={checkedAll} handleCheckedAll={$handleSelectAll} handleChecked={$handleSelected} />
              ) : type === 'console' ? (
                <JobConsole data={job} checkedAll={checkedAll} handleCheckedAll={$handleSelectAll} handleChecked={$handleSelected} />
              ) : (
                <JobLastMile data={job} checkedAll={checkedAll} handleCheckedAll={$handleSelectAll} handleChecked={$handleSelected} />
              )}
              {StateForm?.errors?.jobs ? (
                <div className="invalid-feedback d-block ">
                  {StateForm?.errors?.jobs}
                </div>
              ) : null}
            </div>
          </div>
        </Tab>
        <Tab
          eventKey="input"
          title="Input Shipment"
          tabClassName="section-title bg-white align-items-center justify-content-center"
        >
          <div className="bg-white border rounded p-3">
            <label className="form-label fs-8 required">
              Masukan kode shipment dengan separator koma atau copy-paste dari
              column xls
            </label>
            <Form.Textbox
              label=""
              rows="10"
              value={codes}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  codes: e?.target?.value,
                }))
              }
            />

            {notFounds && notFounds?.length > 0 && (
              <div className="pb-3 fs-8">
                Kode{' '}
                <span className="text-warning ">{notFounds.join(',')}</span>{' '}
                Tidak Ditemukan
              </div>
            )}

            <div className="row w-100">
              <div className="col">
                <Button
                  type="button"
                  className={cn(
                    loading ? 'btn-loading' : '',
                    'btn btn-light w-100'
                  )}
                  disabled={loading}
                  onClick={$handleReset}
                >
                  Reset
                </Button>
              </div>
              <div className="col">
                <Button
                  type="button"
                  className={cn(
                    loading ? 'btn-loading' : '',
                    'btn btn-primary w-100'
                  )}
                  disabled={loading}
                  onClick={$handleSubmit}
                >
                  Cari
                </Button>
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};
